// extracted by css-extract-rspack-plugin
export default {"primaryButton":"VKdtr"};